export default __webpack_public_path__ + "20bd43ee59979c6d1b5682aef22ed74a.png";